

















// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { DisplayJSON} from "@/components.generic/display-code";

export default defineComponent({

	emits:[],
	props:{
		data:{
			type:Object
		}
	},
	components:{
		"display-json":DisplayJSON
	},
	setup(){
		
		

		return {

		};
	}
});

